import { Badge, type BadgeProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type CountBadgeProps = Omit<BadgeProps, 'children'> & {
  children: ReactNode;
};

// Wraps Chakra's Badge with the shape rules baked in so single-digit counts
// render as a circle and multi-digit counts expand to a pill.
export function CountBadge({ children, ...rest }: CountBadgeProps) {
  return (
    <Badge
      borderRadius="full"
      minW={5}
      h={5}
      px={1.5}
      fontSize="xs"
      lineHeight={1}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      {...rest}
    >
      {children}
    </Badge>
  );
}
